import axios from 'axios';
import { useMutation } from '@tanstack/react-query';
import { PACKAGE_SESSION_STORE } from '~/endpoints';
import { PackageSessionStoreResponseSchema } from '~/validation/api/packageSessionResponse';
import { PackageSessionStoreRequest } from '~/types/api';
import { handleErrorResponse } from '~/helpers/api';
import { MutationError } from '~/types/form';

export const storePackageSession = async (obj: PackageSessionStoreRequest) => {
  try {
    const response = await axios.post(PACKAGE_SESSION_STORE, obj);

    const json = response.data;

    return PackageSessionStoreResponseSchema.parse(json);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw await handleErrorResponse(error.response);
    }

    throw error;
  }
};

export default function usePackageSessionStore() {
  return useMutation<any, MutationError, PackageSessionStoreRequest>({
    mutationKey: ['package-session-store'],
    mutationFn: (obj) => {
      return storePackageSession(obj);
    },
  });
}
